import {graphql} from 'relay-runtime'

import type {searchInputLabel$data} from '../__generated__/searchInputLabel.graphql'
import type {searchInputMilestone$data} from '../__generated__/searchInputMilestone.graphql'

export type Milestone = searchInputMilestone$data
export const milestoneFragment = graphql`
  fragment searchInputMilestone on Milestone @inline {
    id
    title
    closed
  }
`

export type Label = searchInputLabel$data
export const labelFragment = graphql`
  fragment searchInputLabel on Label @inline {
    id
    color
    name
    nameHTML
    description
  }
`
